import { useMutation, useQuery } from '@apollo/client'
import { useCallback } from 'react'
import {
  UPDATE_MERCHANT_INTEGRATION_SETTINGS,
  UPDATE_MERCHANT_LOYALTY_ENABLED,
  GET_MERCHANT_INTEGRATIONS
} from '../queries'
import { MerchantIntegrationSettings } from '../types'

export interface SaveLoyaltySettingsVariables {
  enabled: boolean
  password?: string
}

export const useLoyaltySettings = () => {
  const { data, loading: isLoading } = useQuery(GET_MERCHANT_INTEGRATIONS)

  const loyaltySettings: MerchantIntegrationSettings | null =
    data?.getMerchantIntegrations || null

  const [updateLoyaltySettings, { loading: isSavingSettings }] = useMutation(
    UPDATE_MERCHANT_INTEGRATION_SETTINGS,
    { refetchQueries: ['GetMerchantIntegrations'] }
  )

  const [updateLoyaltyEnabled, { loading: isSavingEnabled }] = useMutation(
    UPDATE_MERCHANT_LOYALTY_ENABLED,
    { refetchQueries: ['GetMerchantIntegrations'] }
  )

  const saveLoyaltySettings = useCallback(
    (variables: SaveLoyaltySettingsVariables) => {
      // Without a password there is nothing to write, so use the mutation that
      // omits the field entirely rather than sending an empty one.
      if (!variables.password?.trim()) {
        return updateLoyaltyEnabled({
          variables: { lightspeed_loyalty_enabled: variables.enabled }
        })
      }

      return updateLoyaltySettings({
        variables: {
          lightspeed_loyalty_enabled: variables.enabled,
          lightspeed_loyalty_auth_password: variables.password
        }
      })
    },
    [updateLoyaltySettings, updateLoyaltyEnabled]
  )

  return {
    loyaltySettings,
    isLoading,
    isSaving: isSavingSettings || isSavingEnabled,
    saveLoyaltySettings
  }
}
